/** Diary (design: stories under a frosted "Tap to unveil" cover; they re-veil when you leave). Entries come from Caryn's
 * server (GET /api/messages/diary; for now one welcome entry) - src/api/endpoints.ts diary.list(). */
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { diary, type DiaryPost } from '~/api/endpoints'
import { Icon } from '~/app/ui'
import { usePin } from '~/app/pin'

export function Diary() {
  const navigate = useNavigate()
  const { go } = usePin()
  const [open, setOpen] = useState<Set<number>>(new Set())
  const [DIARY, setDiary] = useState<DiaryPost[] | null>(null)
  useEffect(() => { diary.list().then(setDiary).catch(() => setDiary([])) }, [])
  return (
    <main className="wrap diary-view" id="main">
      <section className="diary-head" aria-labelledby="diaryTitle">
        <p className="eyebrow">Confidential · stories from Caryn</p>
        <h1 id="diaryTitle">My diary</h1>
        <p className="subline">The little things I don’t post anywhere else. Tap a story to unveil it.</p>
      </section>
      {DIARY === null ? <p className="v2-muted" role="status" style={{ padding: '24px 0' }}>Loading…</p> : DIARY.length === 0 ? <p className="subline" style={{ padding: '24px 0' }}>No stories yet.</p> : (
        <div className="posts">
          {DIARY.map((p, i) => {
            const veiled = !open.has(i)
            return (
              <article key={i} className={`post${veiled ? ' veiled' : ''}${p.photo ? ' has-photo' : ''}`} aria-labelledby={`post-t${i}`}>
                {p.photo && <figure className="post-photo"><img src={p.photo} alt={p.alt || ''} width={640} height={960} loading="lazy" decoding="async" /></figure>}
                <div className="post-body">
                  <p className="post-meta"><span>{p.date}</span><span className="tag">{p.mood}</span>{i === 0 && <span className="tag">Newest</span>}</p>
                  <h2 id={`post-t${i}`}>{p.title}</h2>
                  <div className="post-text">{p.text.map((t, k) => <p key={k}>{t}</p>)}{i === 0 && <p className="email-sign">xo, Caryn</p>}</div>
                  {p.gallery && (
                    <div className="post-actions">
                      <button className="btn btn-light" type="button" tabIndex={veiled ? -1 : 0} onClick={() => navigate('/gallery')}>See more in the gallery <Icon id="i-arrow" /></button>
                      <button className="btn btn-quiet" type="button" tabIndex={veiled ? -1 : 0} onClick={() => go('/text')}>Text me back</button>
                    </div>
                  )}
                </div>
                {veiled && <button className="veil" type="button" aria-label={`Unveil this story: ${p.title}`} onClick={() => setOpen((s) => new Set(s).add(i))}><span><Icon id="i-lock" />Tap to unveil</span></button>}
              </article>
            )
          })}
        </div>
      )}
    </main>
  )
}
